import _ from 'lodash'
import itemMixins from './itemMixins'

export default {
  name: 'KMenuItem',
  mixins: [itemMixins],
  props: {
    index: {
      required: true,
      default: null,
    },
    to: { // 路由对象
      type: [String, Object],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    active() {
      return this.menu.activeIndex === this.index
    },
  },
  watch: {
    // 解析默认路由
    $route(to) {
      const location = _.isObject(this.to) ? this.to.path : this.to
      if (location) {
        const route = this.$router.match(location)
        if (route.path === to.path) {
          this.menu.activeIndex = this.index
        }
      }
    },
  },
  created() {},
  methods: {
    handleTitleClick() {
      this.menu.activeIndex = this.index
    },
    getRenderData() {
      const style = {}

      const css = {
        'km-menu__item--disabled': this.disabled,
        'km-menu__item--active': this.active && this.to,
      }

      const attrs = {
        disabled: this.disabled,
      }

      const props = {}

      const events = {}

      const data = {
        style: style,
        class: css,
        attrs: attrs,
        props: props,
        on: events,
      }

      return data
    },
  },
}
